import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "./Upload.css";
import { BASE_URL } from "./Constants";
import useAuth from './useAuth';
const Question = () => {
  const [question, setQuestion] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default to 10 items per page
  const [searchQuery, setSearchQuery] = useState("");
  const [yearFilter, setYearFilter] = useState("all"); 
  const [selectedDept, setSelectedDept] = useState(""); // To filter by department
  useAuth();
  // Fetch questions from API
  useEffect(() => {
    const fetchsetQuestion = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const response = await fetch(`${BASE_URL}question`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch questions");
        const data = await response.json();
        setQuestion(data.question || []); // Ensure you are using the correct key here
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchsetQuestion();
  }, []);

  // Filter questions based on search and department
  useEffect(() => {
  let filtered = question;
  const currentYear = new Date().getFullYear();

  // 🔥 Year Filter Logic
  if (yearFilter === "current") {
    filtered = filtered.filter(
      (q) => new Date(q.created_on).getFullYear() === currentYear
    );
  }

  if (yearFilter === "other") {
    filtered = filtered.filter(
      (q) => new Date(q.created_on).getFullYear() !== currentYear
    );
  }

  // 🔍 Search Filter
  if (searchQuery) {
    filtered = filtered.filter(
      (q) =>
        q.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
        q.dept.toLowerCase().includes(searchQuery.toLowerCase()) ||
        q.rating.toLowerCase().includes(searchQuery.toLowerCase()) ||
        q.created_by.toLowerCase().includes(searchQuery.toLowerCase()) ||
        q.created_on.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  // 🏢 Department Filter
  if (selectedDept) {
    filtered = filtered.filter((q) => q.dept === selectedDept);
  }

  setFilteredQuestions(filtered);
}, [searchQuery, selectedDept, yearFilter, question]);

  // Paginate questions based on the current page and items per page
  const paginateQuestions = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredQuestions.slice(startIndex, endIndex);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page when search changes
  };

  // Handle department filter change
  const handleDeptChange = (e) => {
    setSelectedDept(e.target.value);
    setCurrentPage(1); // Reset to the first page when department filter changes
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page when rows per page changes
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper" >
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">
            {/* Table Section */}
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Questions List</h4>

                    {/* Filters Section */}
                    <div className="mb-3">
                      <div className="row">
                        <div className="col-lg-1">
                          <select
                            className="form-control input-font"
                            value={itemsPerPage}
                            style={{padding:"0px 10px"}}
                            onChange={handleRowsPerPageChange}
                          >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>
                        <div className="col-lg-5">
                          <select
                            className="form-control input-font"
                            value={selectedDept}
                            style={{padding:"0px 10px"}}
                            onChange={handleDeptChange}
                          >
                            <option value="">All Departments</option>
                            {Array.from(new Set(question.map((q) => q.dept))).map((dept) => (
                              <option key={dept} value={dept}>
                                {dept}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-4">
                          <input
                            type="text"
                            className="form-control input-font"
                            placeholder="Search questions"
                            value={searchQuery}
                            onChange={handleSearchChange}
                          />
                        </div>
                        <div className="col-lg-1">
  <select
    className="form-control input-font"
    style={{padding:"0px 10px"}}
    value={yearFilter}
    onChange={(e) => {
      setYearFilter(e.target.value);
      setCurrentPage(1);
    }}
  >
    <option value="all">All Years</option>
    <option value="current">Current Year</option>
    <option value="other">Other Years</option>
  </select>
</div>
                      </div>
                      
                    </div>

                    {/* Display loading or error messages */}
                    {loading && <p>Loading...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}

                    {/* Render Paginated Questions Table */}
                    {!loading && !error && filteredQuestions.length > 0 && (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Department</th>
                              <th>Question</th>
                              <th>Rating</th>
                              <th>Created By</th>
                              <th>Created On</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginateQuestions().map((questionItem, index) => (
                              <tr key={questionItem.id}>
                                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                <td>{questionItem.dept}</td>
                                <td>{questionItem.question}</td>
                                <td>{questionItem.rating}</td>
                                <td>{questionItem.created_by}</td>
                                <td>{questionItem.created_on}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
<br/>
                        {/* Pagination Controls */}
                        <div className="pagination">
                          <button
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="btn btn-secondary"
                          >
                            Previous
                          </button>
                          <span className="mx-3">Page {currentPage}</span>
                          <button
                            onClick={() =>
                              setCurrentPage((prev) =>
                                Math.min(prev + 1, Math.ceil(filteredQuestions.length / itemsPerPage))
                              )
                            }
                            disabled={currentPage === Math.ceil(filteredQuestions.length / itemsPerPage)}
                            className="btn btn-secondary"
                          >
                            Next
                          </button>
                        </div>

                        {/* Rows Count Display */}
                        <div className="row-count-display">
                          <p>
                            Showing {(currentPage - 1) * itemsPerPage + 1}-
                            {Math.min(currentPage * itemsPerPage, filteredQuestions.length)} of{" "}
                            {filteredQuestions.length} rows
                          </p>
                        </div>
                      </>
                    )}

                    {/* No data found message */}
                    {!loading && !error && filteredQuestions.length === 0 && (
                      <p>No questions found</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="footer">
        <span className="text-muted">© {new Date().getFullYear()} Vijaya Diagnostic Centre</span>
      </footer>
        </div>
      </div>

     
    </div>
  );
};

export default Question;
